import React from 'react';
import { bonusAgainstDesignationsColList, uploadColumns } from '../../constants/MockData';
import {
  AppBar,
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Tooltip,
  Typography
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, downloadReport } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import { GenerateAbsoluteURL, isGridFormValid, IsSectionVisible, UpdateColumnWithConfiguration, with2DecimalsPoints } from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { DateFormat, SECTIONS, EXCEL_FILE } from '../../constants/appConstants';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import _, { update } from 'lodash';
import moment from 'moment';
import { CloudUploadOutlined } from '@material-ui/icons';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';

// Component used to get/set Employee Title (Designation) wise Bonus
export default class ConfigureBonusAgainstDesignations extends React.PureComponent {
  // Constructor to set initial state
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();

    this.state = {
      confirmMessage: null,
      validationMessage: [],
      designationMasterData: [],
      bonusAgainstDesignationData: [],
      isInAddMode: false,
      isDelete: false,
      showWarningMessage: false,
      configuration: [],
      selectedEditRowId: undefined,
      isEditEnable: true,
      updateData: {
        designationBonusId: 0,
        designationId: 0,
        bonusPercent: 0,
        designation: null,
        statusId: 1,
        startDate: null
      },
      bonusAgainstDesignationsColumns: _.cloneDeep(bonusAgainstDesignationsColList),
      openUploadFileSuccess: false,
      invalidRecord: [],
      yearEndBonusData: []
    };
  }

  /**
  Method used to get data from API before components are mounted
     */
  componentDidMount() {
    this.getRequiredData();
  }

  /**
* return master data from APIs
*/
  getRequiredData = () => {
    // Configure Bonus Per Against Designation APIS
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetDesignationMasterData,
        key: 'designationMasterData'
      },
      {
        url: API_URL.Users.GetDesignationBonus,
        key: 'bonusAgainstDesignationData'
      },
      {
        url: API_URL.Users.GetYearEndBonusConfiguration + '?yearEndBonusConfigurationId=' + 0 + '&year=' + 0,
        key: 'yearEndBonusData'
      }
    ])
      .then(({ bonusAgainstDesignationData, designationMasterData, yearEndBonusData }) => {
        this._asyncRequest = null;
        if (designationMasterData.success !== true) {
          ShowToast(
            'Something went wrong',
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          designationMasterData: designationMasterData.data,
          bonusAgainstDesignationData: bonusAgainstDesignationData.data || [],
          configuration: bonusAgainstDesignationData.config || [],
          reloadTable: !this.state.reloadTable,
          yearEndBonusData: yearEndBonusData.data || []
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  /**
   * add new record in grid table
   * @returns
   */
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const bonusAgainstDesignationsColumns = _.cloneDeep(bonusAgainstDesignationsColList);
    const rowNew = {
      designationBonusId: 0,
      designationId: 0,
      bonusPercent: 0,
      designation: null,
      statusId: 1,
      startDate: null
    };

    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: 'designationBonusId', value: 0 },
      reloadTable: !this.state.reloadTable,
      updateData: rowNew,
      bonusAgainstDesignationsColumns
    });
  };

  /**
   * cancel row open for add mode
   */
  cancelAddMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      reloadTable: !this.state.reloadTable
    });
    this.getRequiredData();
  };

  /**
   * cancel row open for edit mode
   */
  cancelEditMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      reloadTable: !this.state.reloadTable
    });
    this.getRequiredData();
  };

  // Open selected record in Edit mode
  EditRecord = (cellInfo) => {
    const bonusAgainstDesignationsColumns = _.cloneDeep(bonusAgainstDesignationsColList);

    this.setState({
      bonusAgainstDesignationsColumns,
      selectedEditRowId: {
        key: 'designationBonusId',
        value: cellInfo.designationBonusId
      },
      isInAddMode: false,
      updateData: cellInfo,
      reloadTable: !this.state.reloadTable
    });
  }

  // Handle delete confirmation
  onClickHandle(e) {
    if (this.state.isDelete) {
      this.onDeleteHandle(e);
    }
  }

  // Click event of Delete action button
  deleteRecord(cellInfo) {
    this.setState({
      isDelete: true,
      showWarningMessage: true,
      confirmMessage: 'Do you want to delete this record ?',
      updateData: cellInfo
    });
  };

  // Handle delete event of record
  onDeleteHandle(e) {
    const newParam = this.state.updateData;
    if (e) {
      newParam.statusId = 11;
      apiPost({
        url: API_URL.Users.UpdateSDCBudgetedPercentConfiguration,
        postBody: newParam
      }
      ).then(({ data: response }) => {
        if (response.success === true) {
          ShowToast('Record deleted successfully.',
            toastType.SUCCESS,
            5000,
            500
          );

          this.setState({
            updateData: undefined,
            selectedEditRowId: undefined,
            reloadTable: !this.state.reloadTable,
            isDelete: false,
            showWarningMessage: false
          });
          this.getRequiredData();
          this.forceUpdate();
        } else {
          ShowToast(
            response.message,
            toastType.ERROR,
            5000,
            5000
          );
        }
      });
    } else {
      this.setState({ showWarningMessage: false, confirmationMessage: '' });
    }
  }

  // Check whether to show Edit icon for the record
  isEditIconVisible = (cellInfo) => {
    let isVisible = false;
    if (IsSectionVisible(SECTIONS.YEAR_END_BONUS, SECTIONS.CONFIGURE_YEARLY_BONUS_TITLE, SECTIONS.ADD_EDIT)) {
      isVisible = true;
      const formattedDate = moment(cellInfo.startDate).format('YYYY/MM/DD');
      return moment(formattedDate, 'YYYY/MM/DD').year() >= moment().year();
    }
    return isVisible;
  }

  /**
  * render action column on grid table
  * @param {*} cellInfo
  * @param {*} isInAddMode
  * @returns
  */
  renderActionColumn = (cellInfo, key, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.designationBonusId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => { }}
                >
                  <SaveIcon
                    fontSize="small"
                    size="small"
                    onClick={this.saveUpdatedRecord

                    }
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={this.cancelEditMode}
                >
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : <>
            {this.isEditIconVisible(cellInfo) && (
              <Tooltip title="Edit Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                      ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                      return false;
                    } else {
                      this.EditRecord(cellInfo);
                    }
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>)}
          </>
        }
      </>
    );
  };

  /**
   * is Form Valid
   */
  isValidForm = () => {
    let IsValid = true;
    const { updateData, bonusAgainstDesignationsColumns } = this.state;
    bonusAgainstDesignationsColumns.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ bonusAgainstDesignationsColumns }, this.forceUpdate());
    return IsValid;
  };

  // Check the record exists with same designation and same year
  isDesignationWithSameYear = () => {
    const { updateData, bonusAgainstDesignationData } = this.state;
    const designationData = bonusAgainstDesignationData.find(x => x.designationId === updateData.designationId && x.designationBonusId !== updateData.designationBonusId &&
      moment(moment(x.startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year() === moment(moment(updateData.startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year());

    return designationData !== undefined;
  }

  /**
   * save Updated Record to database
   */
  saveUpdatedRecord = () => {
    const { updateData } = this.state;
    if (!this.isValidForm()) { return false; } else {
      if (this.isDesignationWithSameYear()) {
        ShowToast(
          'Same Title: ' + updateData.designation + ' is already mapped to Year: ' + moment(moment(updateData.startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year(), toastType.ERROR,
          5000,
          500
        );
        return false;
      } else {
        const newParam = this.state.updateData;
        newParam.statusId = 1;
        apiPost({
          url: API_URL.Users.UpdateYearEndBonusDesignationConfiguration,
          postBody: newParam
        }
        ).then(({ data: response }) => {
          if (response.success === true) {
            ShowToast(
              this.state.isInAddMode
                ? 'Record added successfully.'
                : 'Record updated successfully.',
              toastType.SUCCESS,
              5000,
              500
            );

            this.setState({
              updateData: undefined,
              selectedEditRowId: undefined,
              reloadTable: !this.state.reloadTable,
              isInAddMode: false
            }, () => {
              this.getRequiredData();
              this.forceUpdate();
            });
          } else {
            ShowToast(
              response.message,
              toastType.ERROR,
              5000,
              5000
            );
          }
        });
      }
    }
  };

  /**
 * handle on change
 * @param {*} value
 * @param {*} fieldName
 */
  handleTableEditChange = (value, fieldName) => {
    const { bonusAgainstDesignationsColumns, designationMasterData } = this.state;
    const param = this.state.updateData;
    const validationMessage = this.state.validationMessage;
    if (fieldName === 'designation') {
      const designationData = designationMasterData.find((x) => x.designation === value);
      param.designationId = (designationData || {}).designationID;
      param[fieldName] = value;
    } else if (fieldName === 'bonusPercent') {
      param[fieldName] = parseFloat(with2DecimalsPoints(value));
    } else {
      param[fieldName] = value;
    }

    isGridFormValid(value, bonusAgainstDesignationsColumns.find(x => x.key === fieldName), param);
    const selectedField = bonusAgainstDesignationsColumns.find((x) => x.key === fieldName);

    if (selectedField.dependentFieldValidation !== undefined && selectedField.dependentFieldValidation.length > 0) {
      selectedField.dependentFieldValidation.forEach(x => {
        if (param[x] !== undefined && param[x] !== '' && param[x] !== null) {
          const ele = bonusAgainstDesignationsColumns.find((y) => y.key === x);
          isGridFormValid(
            param[x],
            ele,
            param
          );
        }
      });
    }
    this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) }, () => {
      this.forceUpdate();
    });
  };

  // Handle event of file selected/changed
  onFileChange = (e) => {
    const { files } = e.target;
    if (files && files.length) {
      const filename = files[0].name;

      const parts = filename.split('.');
      const fileType = parts[parts.length - 1];
      const excelFileExtension = ['xls', 'xlsx'];
      if (excelFileExtension.includes(fileType.toLowerCase())) {
        this.uploadFile(files);
      } else {
        ShowToast('File format is not supported. Please upload xls or xlsx file.', toastType.ERROR, 5000);
      }
    }
  }

  // Upload file
  uploadFile = (files) => {
    const f = new FormData();
    f.append('FormFile', files[0]);
    f.append('FileName', files[0].name);
    f.append('YearEndBonus', JSON.stringify(this.state.yearEndBonusData));
    apiPost({
      url: API_URL.Users.UploadEmployeeBonusByTitle,
      postBody: f
    }
    ).then(({ data: response }) => {
      if (response.success === true) {
        if (response.data && response.data.length > 0) {
          this.setState({ invalidRecord: response.data, openUploadFileSuccess: true });
        } else {
          ShowToast(
            'Excel file for Employee Bonus by Title is uploaded successfully.',
            toastType.SUCCESS,
            5000,
            500
          );
          this.getRequiredData();
        }
      } else {
        ShowToast(
          response.message,
          toastType.ERROR,
          5000,
          5000
        );
      }
    });
  }

  // Download file with errorneous records
  downloadFile = (fileMimeType, type, isPrint = false) => {
    const { invalidRecord } = this.state;
    const dataValue = [
      {
        key: 'SSRSData',
        value: invalidRecord.length > 0 ? JSON.stringify(invalidRecord) : null
      },
      {
        key: 'ReportType',
        value: 'Configure Employee Bonus By Title'
      }
    ];
    const url = GenerateAbsoluteURL(dataValue, [], 'Display%20JSON%20Data%20In%20SSRS', type, false, true);

    downloadReport(
      url,
      'Invalid Employee Bonus by Title',
      fileMimeType,
      type,
      isPrint
    );
  }

  // Download template file with sample data
  downloadSampleFile = () => {
    fetch(EXCEL_FILE).then(response => {
      response.blob().then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Employee Bonus by Title Template.xlsx';
        a.click();
      });
    });
  }

  // Button click event to select file from file explorer
  onButtonClick = () => {
    this.inputFile.current.click();
  }

  /**
   * render elements to UI
   * @returns UI
   */
  render() {
    const { designationMasterData, configuration, bonusAgainstDesignationsColumns, openUploadFileSuccess, invalidRecord } = this.state;

    const EditSource = [];
    EditSource.push({
      key: 'designationMasterData',
      data: designationMasterData
    });
    return (
      <>
        {openUploadFileSuccess && (
          <Dialog open={openUploadFileSuccess} maxWidth="xs" fullWidth={true} >
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  Invalid Employee Bonus by Title Record(s)
                    </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="close"
                  style={{ paddingLeft: '40px' }}
                >
                  <IoMdCloseCircleOutline onClick={() => {
                    this.setState({ invalidRecord: [], openUploadFileSuccess: false }, () => { this.getRequiredData(); });
                  }}
                  />
                </IconButton>
              </Toolbar>
            </AppBar>
            <DialogContent dividers>
              <DialogContentText style={{ color: '#002f6c' }}>
                <label>
                  <p>
                    Records for employee bonus by title are imported successfully, but there are some invalid record(s). Click on below icon to download the same.
                        </p>
                </label>
                {invalidRecord?.length > 0 &&
                  <div style={{ float: 'right' }}>
                    <Tooltip title="Export Excel">
                      <IconButton
                        size="small"
                        onClick={() => this.downloadFile('application/vnd.ms-excel', 'Excel')}>
                        <div style={{ fontSize: '1.5rem', color: '#05375E' }}>
                          <AssignmentIcon />
                        </div>
                      </IconButton>
                    </Tooltip>
                  </div>}
              </DialogContentText>
            </DialogContent>

          </Dialog>
        )}
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onClickHandle(isValid);
              } else {
                this.onClickHandle(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Configure Employee Bonus By Title
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(IsSectionVisible(SECTIONS.YEAR_END_BONUS, SECTIONS.CONFIGURE_YEARLY_BONUS_TITLE, SECTIONS.ADD_EDIT)) && (
              <TableRow>
                <TableCell align='right'>
                  <Tooltip title="Upload Document">
                    <IconButton
                      className="action-button"
                      variant="contained"
                      size="small"
                      component="label"
                      onChange={(event) => {
                        this.onButtonClick();
                      }}
                    >
                      <CloudUploadOutlined size="small"></CloudUploadOutlined>
                      <input
                        type="file"
                        hidden
                        ref={this.inputFile}
                        onChange={(event) => {
                          this.onFileChange(event);
                        }}
                        onClick={(event) => {
                          event.target.value = null;
                        }}
                        accept=".xlsx, .xls"
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Dowload Sample Document">
                    <IconButton
                      className="action-button"
                      variant="contained"
                      size="small"
                      component="label"
                      onClick={(event) => {
                        this.downloadSampleFile();
                      }}
                    >
                      <CloudDownloadOutlinedIcon size="small"></CloudDownloadOutlinedIcon>
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>
                <GridTable
                  validationMessage={this.state.validationMessage || []}
                  columns={UpdateColumnWithConfiguration(
                    bonusAgainstDesignationsColumns,
                    configuration,
                    []
                  )}
                  data={this.state.bonusAgainstDesignationData}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={this.state.selectedEditRowId}
                  isInAddMode={this.state.isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={this.state.updateData}
                  AddNewRecord={{
                    action: this.AddNewRecord,
                    title: 'Add New Employee Bonus By Title',
                    visible: IsSectionVisible(SECTIONS.YEAR_END_BONUS, SECTIONS.CONFIGURE_YEARLY_BONUS_TITLE, SECTIONS.ADD_EDIT)
                  }}
                  isInline={true}
                  reload={this.state.reloadTable}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}
